import type { Organization } from "@/models/organization"
import type { BillPeriodListApiQueryOptions } from "@/services/core-api/types"

interface BillPeriodsExportQuery {
  format?: "csv" | "xlsx"
  isIntervalDerived?: NonNullable<
    BillPeriodListApiQueryOptions["is_interval_derived"]
  >
  /** Core's comma-separated meter id list (e.g. "1,2,3"), sent with `siteId`. */
  meterIds?: string
  resourceType?: string
  siteId: BillPeriodListApiQueryOptions["site_id"]
  sort?: string
  startDateFrom?: string
  startDateTo?: string
}

/** The bill-periods export link. The gateway refuses an export without a site. */
export const buildBillPeriodsExportPath = (
  organizationId: Organization["id"],
  query: BillPeriodsExportQuery
): string => {
  const params = new URLSearchParams({
    format: query.format ?? "csv",
    site_id: String(query.siteId),
  })
  if (query.isIntervalDerived != null) {
    params.set("is_interval_derived", String(query.isIntervalDerived))
  }
  if (query.meterIds) {
    params.set("meter_ids", query.meterIds)
  }
  if (query.resourceType) {
    params.set("resource_type", query.resourceType)
  }
  if (query.sort) {
    params.set("sort", query.sort)
  }
  if (query.startDateFrom) {
    params.set("start_date_from", query.startDateFrom)
  }
  if (query.startDateTo) {
    params.set("start_date_to", query.startDateTo)
  }

  return `/api/v1/organizations/${organizationId}/bill-periods/export?${params.toString()}`
}
